import { z } from "zod";
// The proposal the server binds into the HMAC fingerprint at intent creation.
// It must be sent byte-identical (same object reference, not a rebuilt copy)
// to booking creation — any reformatting invalidates the child grant.
export const BookingProposalSchema = z.object({
    serviceId: z.number(),
    startDateTime: z.string(),
    endDateTime: z.string(),
    partySize: z.number().int().min(1),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    email: z.string().email(),
    country: z.string().length(2),
    phone: z.string().optional(),
});
